export const QUESTION_TYPE = 'QUESTION';
export const ISSUE_TYPE = 'ISSUE';
export const TODO_TYPE = 'TODO';
export const SUGGEST_CHANGE_TYPE = 'SUGGEST';
export const REPLY_TYPE = 'REPLY';
export const REPORT_TYPE = 'REPORT';
export const JUSTIFY_TYPE = 'JUSTIFY';